import OperationsStore from './OperationsStore'
import {debounce} from 'lodash'

let logger

const DEFAULT_TIMEOUT_BEFORE_CONSIDER_IDLE = 15000
const CHECK_IDLE_TIMEOUT = 1000

const callbackOnIdle = window.requestIdleCallback
  ? fn => window.requestIdleCallback(fn, {timeout: DEFAULT_TIMEOUT_BEFORE_CONSIDER_IDLE})
  : fn => setTimeout(fn)

let isIdle = false
let frozen = false
let setIdleTimeout
let operationsStore

function setIdle(){
  logger.log('Idle started')
  isIdle = true
}

export function addDeferredOperation(operation){
  operationsStore.addOperation(operation)
}

export function removeDeferredOperations(operationType){
  operationsStore.removeOperation(operationType)
}

export function freezeDeferredOperations() {
  logger.debug('Freeze deferred operations')
  frozen = true
}

export function unfreezeDeferredOperations() {
  logger.debug('Unfreeze deferred operations')
  // we dont want to run an operation immediately after an unfreeze
  setNotIdle()
  frozen = false
}

export const setNotIdle = debounce(() => {
  isIdle = false
  logger.debug(`Set deferred operations idle timout: ${DEFAULT_TIMEOUT_BEFORE_CONSIDER_IDLE}`)
  clearTimeout(setIdleTimeout)
  setIdleTimeout = setTimeout(setIdle, DEFAULT_TIMEOUT_BEFORE_CONSIDER_IDLE)
}, CHECK_IDLE_TIMEOUT, {maxWait: DEFAULT_TIMEOUT_BEFORE_CONSIDER_IDLE - 1000})

function tryToRunOperation(){
  if (frozen || !isIdle || !operationsStore.hasOperations()){
    setTimeout(tryToRunOperation, CHECK_IDLE_TIMEOUT)
    return
  }

  callbackOnIdle(() => {
    operationsStore.runOldestOperation()
      .then(tryToRunOperation)
  })
}

export function init({logger: newLogger} = {}){
  if (!newLogger){
    throw new Error('Please supply a logger to the deferredOperations init function. (it can be console)')
  }
  logger = newLogger
  operationsStore = new OperationsStore({logger})
  tryToRunOperation()
}

export function wait(ms = 0) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
